import { IsNumber, IsString } from 'class-validator';

export class OperationRuleDto {
  @IsString()
  operation: string;
  @IsNumber()
  value: number;
}
